<template>
  <div v-if="show" class="gx-loading">
    <div class="gx-loading__inner">
      <svg class="gx-loading__ring" viewBox="0 0 48 48" fill="none">
        <circle cx="24" cy="24" r="20" stroke="rgba(212,169,70,.18)" stroke-width="4" />
        <circle class="gx-loading__arc" cx="24" cy="24" r="20" stroke="url(#gxLgGrad)" stroke-width="4" stroke-linecap="round" pathLength="100" />
        <defs>
          <linearGradient id="gxLgGrad" x1="0" y1="0" x2="48" y2="48">
            <stop offset="0%" stop-color="#F0C44A" />
            <stop offset="100%" stop-color="#D4A946" />
          </linearGradient>
        </defs>
      </svg>
      <span class="gx-loading__text">{{ text }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GxLoading',
  props: {
    show: { type: Boolean, default: false },
    text: { type: String, default: '加载中...' }
  }
}
</script>

<style scoped>
.gx-loading {
  position: fixed;
  inset: 0;
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(7, 14, 34, .45);
  backdrop-filter: blur(3px);
}
.gx-loading__inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 32px 44px;
  border-radius: 16px;
  background: linear-gradient(160deg, rgba(13, 22, 48, .96), rgba(21, 34, 72, .96));
  border: 1px solid rgba(212, 169, 70, .25);
  box-shadow: 0 18px 48px rgba(0, 0, 0, .5);
}
.gx-loading__ring {
  width: 44px;
  height: 44px;
  animation: gx-loading-rotate 1s linear infinite;
}
.gx-loading__arc {
  stroke-dasharray: 60 40;
  animation: gx-loading-dash 1.2s ease-in-out infinite;
  transform-origin: center;
}
.gx-loading__text {
  font-size: 13px;
  color: var(--gx-white, #F0EBE0);
  letter-spacing: 1px;
}
@keyframes gx-loading-rotate {
  to { transform: rotate(360deg); }
}
@keyframes gx-loading-dash {
  0% { stroke-dasharray: 60 40; stroke-dashoffset: 0; }
  50% { stroke-dasharray: 40 60; stroke-dashoffset: 20; }
  100% { stroke-dasharray: 60 40; stroke-dashoffset: 0; }
}
</style>
